import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { updateUser } from '../auth/api/updateUserData';
import { selectOptionalUser } from '../auth/store/authSelectors';
import { getAppLocale } from '../i18n/utils/getAppLocale';
import { getLinkLocale } from '../i18n/utils/getLinkLocale';
import { logger } from '../logger/logger';
import { datadogRumAddCustomAction } from '../monitoring/customDatadogRumActions';
import { useAppSelector } from '../store/hooks';

export const useSetUrlLocale = () => {
  const user = useAppSelector(selectOptionalUser);
  const [localeInitialized, setLocaleInitialized] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (!user) return;
    const state = location.state as { passedSearch: string } | null;
    const searchString =
      window.location.search.length > 0
        ? window.location.search
        : state?.passedSearch;
    const locale = searchString ? getLinkLocale(searchString) : undefined;
    const userLanguage = getAppLocale(user.language);

    if (locale && locale !== userLanguage) {
      datadogRumAddCustomAction({
        name: 'userChangeLanguage',
        details: {
          from: userLanguage,
          to: locale,
        },
      });

      updateUser(user.uid, { language: locale }).catch((error: unknown) => {
        logger.warn(
          'User language could not be saved',
          undefined,
          error as Error
        );
      });
    }

    setLocaleInitialized(true);
  }, [location.state, user]);

  return localeInitialized;
};
